import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import SodInstallation from "@/pages/SodInstallation";
import Concrete from "@/pages/Concrete";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/sod-installation" element={<SodInstallation />} />
        <Route path="/concrete" element={<Concrete />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
